import { Link } from "react-router-dom";
import { ChevronRight, ArrowRight } from "lucide-react";
import { Reveal, Counter } from "../components/Reveal";

export default function About() {
  return (
    <div data-testid="about-page" className="pt-32 pb-24 bg-[#FAFAFA]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="flex items-center gap-2 text-[11px] tracking-widest uppercase text-[#888] mb-8">
          <Link to="/" className="hover:text-[#B8860B]">Ana Sayfa</Link>
          <ChevronRight size={12} />
          <span className="text-[#1E1E1E]">Kurumsal</span>
        </div>

        <div className="mb-16 max-w-4xl">
          <div className="text-[10px] tracking-[0.35em] uppercase text-[#B8860B] mb-4">
            Hakkımızda
          </div>
          <h1 className="font-serif-display text-3xl md:text-4xl text-[#1E1E1E] leading-tight">
            Hakkımızda
          </h1>
        </div>

        <div className="grid lg:grid-cols-12 gap-16 items-start mb-24">
          <div className="lg:col-span-7">
            <div className="clip-frame aspect-[4/3] overflow-hidden">
              <img src="/catalog/vesna-hero.jpg" alt="SeraPark Showroom" className="w-full h-full object-cover" />
            </div>
          </div>
          <div className="lg:col-span-5 space-y-4 text-[14px] text-[#555] leading-[1.7]">
            <p>SeraPark, 2007'de Şanlıurfa'da kurulan; premium seramik, porselen ve yapı malzemelerini tek çatı altında buluşturan bir kürasyon atölyesidir.</p>
            <p>17 yıllık deneyimimizle 520'yi aşkın referans projede imzamız var.</p>
          </div>
        </div>

        <div id="misyon" className="grid lg:grid-cols-3 gap-6 md:gap-10 mb-24">
          {[
            { n: "01", t: "Misyon", d: "Zamansız kaliteli yüzeyleri, mimari çözüm ortaklığıyla sunmak." },
            { n: "02", t: "Vizyon", d: "Premium seramik kürasyonunda ilk akla gelen adres olmak." },
            { n: "03", t: "Kalite", d: "Her koleksiyon uluslararası standartlara uygun ve showroom'da test edilir." },
          ].map((c) => (
            <Reveal key={c.n}>
              <div id={c.t.toLowerCase()} className="p-10 bg-white border border-black/5 h-full">
                <div className="font-serif-display text-4xl text-[#B8860B]">{c.n}</div>
                <h3 className="mt-4 font-serif-display text-xl text-[#1E1E1E]">{c.t}</h3>
                <p className="mt-3 text-[13px] text-[#666] leading-relaxed">{c.d}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <div id="kalite" className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-4 py-16 border-y border-black/8">
          {[
            { v: 17, s: "+", l: "Yıl Deneyim" },
            { v: 8000, s: "", l: "m² Showroom" },
            { v: 520, s: "+", l: "Referans Proje" },
            { v: 40, s: "+", l: "Marka" },
          ].map((k) => (
            <div key={k.l} className="text-center md:text-left">
              <div className="font-serif-display text-4xl md:text-5xl text-[#1E1E1E]">
                <Counter to={k.v} suffix={k.s} />
              </div>
              <div className="mt-2 text-[10px] tracking-[0.3em] uppercase text-[#888]">{k.l}</div>
            </div>
          ))}
        </div>

        <div className="mt-24 text-center">
          <h2 className="font-serif-display text-2xl md:text-4xl text-[#1E1E1E]">
            Showroom'umuza bekleriz
          </h2>
          <div className="mt-8 flex justify-center gap-3 flex-wrap">
            <Link to="/iletisim" className="btn-gold">Bize Ulaşın <ArrowRight size={14} /></Link>
            <Link to="/projeler" className="btn-ghost">Projelerimizi İnceleyin</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
